/**
 * Returns a UUID that is stable for the lifetime of this browser tab session.
 * Stored in sessionStorage so it resets when the tab is closed (a new session
 * = a new visitor identity for referral dedup purposes).
 *
 * The token is sent to /referral-start/ and embedded in the server-signed
 * referral token, so the backend can derive a per-session fingerprint that
 * cannot be altered at score-submission time.
 */
export const getOrCreateVisitorToken = () => {
  const KEY = "qf_visitor_token";
  let token = sessionStorage.getItem(KEY);
  if (!token) {
    token = crypto.randomUUID();
    sessionStorage.setItem(KEY, token);
  }
  return token;
};
